import { useQuery } from '@tanstack/react-query';
import { queryFn, getDividendsTimeseriesDataKey, ParamsType } from './queryFn';
import type { DivPaymentDetailRawData } from './types';

type DividenDataSuccessResponse = {
  status: 'success';
  data: DivPaymentDetailRawData;
};

type DividenDataLoadingResponse = {
  status: 'pending';
  data: undefined;
};

type DividenDataErrorResponse = {
  status: 'error';
  data: undefined;
};

type DividenDataResponse =
  | DividenDataSuccessResponse
  | DividenDataLoadingResponse
  | DividenDataErrorResponse;

export const useDividendsData = ({ id }: ParamsType): DividenDataResponse => {
  const { data, status } = useQuery({
    queryKey: getDividendsTimeseriesDataKey({ id }),
    queryFn,
    staleTime: 3600000,
    enabled: !!id,
  });

  if (status === 'success') {
    return { status, data: data };
  }

  return { status, data: undefined };
};
